export default function SectionTitle({ action, children }) {
  return (
    <div className="border-b border-gray-200 flex items-center py-3 px-4 h-16 bg-white">
      <div className="text-lg text-gray-700 font-medium">{children}</div>
      <div className="ml-auto">{action}</div>
    </div>
  )
}
